import { render, staticRenderFns } from "./TemplateComponent.vue?vue&type=template&id=ff526e5c&scoped=true"
import script from "./TemplateComponent.vue?vue&type=script&lang=js"
export * from "./TemplateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff526e5c",
  null
  
)

export default component.exports